module.exports = __webpack_public_path__ + "img/img2.a3e29a86.png";